import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { TowersBetSectionComponent } from "./towers-bet-section/towers-bet-section.component";
import { TowersAreaComponent } from "./towers-area/towers-area.component";
import { TowersService } from './towers.service';

@Component({
  selector: 'app-towers',
  templateUrl: './towers.component.html',
  styleUrls: ['./towers.component.scss'],
  imports: [TowersBetSectionComponent, TowersAreaComponent],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TowersComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly towersService = inject(TowersService);
  
  constructor() {
    this.destroyRef.onDestroy(() => {
      if (this.towersService.currentGame()?.status === 'finished') {
        this.towersService.clearArea();
      }
    })
  }
}
